import { InputAdornment, TextField } from "@mui/material";
import { FunctionComponent, useEffect, useState } from "react";
import { TextFieldProps } from "@mui/material";
import { UNITS } from "@shared/types";
import { UnitMenu } from "../LengthSelector/UnitMenu";

export const CoreInlineNumber: FunctionComponent<{
  number?: number;
  unit?: UNITS;
  onNumberChange: (number: number | null) => void;
  onUnitChange: (unit: string) => void;
  textFieldProps?: TextFieldProps;
  noUnit?: boolean;
}> = ({
  textFieldProps,
  number,
  onNumberChange,
  unit,
  onUnitChange,
  noUnit,
}) => {
  const [numberInput, setNumberInput] = useState<string>(
    number != null ? String(number) : ""
  );
  useEffect(() => {
    try {
      const num = parseFloat(numberInput);
      onNumberChange?.(Number.isNaN(num) ? null : num);
    } catch (error) {}
  }, [numberInput]);

  return (
    <TextField
      {...textFieldProps}
      size="small"
      value={numberInput}
      onChange={(e) => setNumberInput(e.target.value)}
      InputProps={
        !noUnit
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <UnitMenu
                    unit={unit || ""}
                    onChange={(unit) => {
                      onUnitChange(unit || "");
                    }}
                  />
                </InputAdornment>
              ),
            }
          : undefined
      }
    />
  );
};
